import React from "react";
import {
  ComponentDeploymentRequestListPageInitialState,
  PageNewState,
} from ".";

export const ComponentDeploymentRequestListPageContext = React.createContext({
  pageState: ComponentDeploymentRequestListPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
